import React from "react";
import { useQuery } from "@apollo/client";
import { Link, useParams } from "react-router-dom";
import { PropertyDuplicatesCount, UserRole } from "types/gql-types";
import { PROPERTY_DUPLICATES_COUNT } from "pages/duplicates/queries";
import { authorizeForRole } from "components/auth/authorize-for-role";


export const Duplicates: React.FC<{ interestListId?: string }> = ({ interestListId }) => {
  const { interestListId: listIdParam } = useParams();
  const id = interestListId || listIdParam;
  const { data, loading, error } = useQuery<PropertyDuplicatesCount>(PROPERTY_DUPLICATES_COUNT, {
    fetchPolicy: "cache-and-network",
    variables: { id },
  });

  if (error) return <span>Error loading duplicates</span>;
  if (!data || loading) return null;

  const listId = data.interestList.id;

  return (
    <Link to={`/dash/manager/duplicates/${listId}`} style={{ marginRight: 20 }}>
      Duplicates ({data.interestList?.property?.duplicatesCount})
    </Link>
  );
};

export default authorizeForRole([UserRole.PROPERTY_MANAGER, UserRole.SUPERVISOR], Duplicates);
